import { useEffect, useState } from "react";
import { getExtraData, getProjectData } from "../_shoru_shared_library/firebase/firebase_setup";
import PageLoader from "../_shoru_shared_library/loaders/PageLoader";
import PrettifyDate from "../_shoru_shared_library/functions/PrettifyDate";
import { bookAudition, checkAuditioneeByEmail, createAuditioneeAndBookAudition, getAuditionee } from "../CastingBotFirebase";
import Logo from '../_media/branding/logo.svg';
import LoaderImage from '../_media/loaders/loader.gif';

function BookingPage(props) {

  const url = window.location.pathname.split("/");
  const organisation = url[url.length - 2];
  const project = url[url.length - 1];

  const [projectData, setProjectData] = useState(null);
  const [castingData, setCastingData] = useState(null);
  const [times, setTimes] = useState(null);

  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');

  const [infoFormState, setInfoFormState] = useState(0);
  const [bookingInProgress, setBookingInProgress] = useState(false);
  const [auditionee, setAuditionee] = useState(null);
  const [date, setDate] = useState(null);
  const [slot, setSlot] = useState(null);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  useEffect(() => {
    // These extra checks are in place to stop an endless loop of calling to the server
    if(projectData === null)
    {
      getProjectData(organisation, project, setProjectData);
    }
    if(castingData === null)
    {
      getExtraData('castingbot', organisation, project, setCastingData);
    }
    //eslint-disable-next-line
  }, [])

  if(projectData === null || castingData === null) return <PageLoader />
  if(projectData === undefined) window.location.replace('/');
  if(times === null && castingData.times.length > 0) setTimes([]);

  if(times !== null && times.length === 0) {
    var newTimes = castingData.times;
    let currentDate = new Date().toJSON().slice(0,10);
    newTimes.sort((a,b) => {return a.start < b.start? 1 : -1});
    newTimes.sort((a,b) => {return a.date > b.date? 1 : -1});
    newTimes = newTimes.filter((x) => {return x.date >= currentDate});
    setTimes(newTimes);
  }

  if(castingData.booking_enabled === false)
  {
    return <BookingDisabled showName={projectData.name} />
  }
  else
  {
    if      (date === null)              return <DatesDisplay projectData={projectData} times={times} setDate={setDate} />
    else if (slot === null)              return <SlotsDisplay projectData={projectData} castingData={castingData} date={date} setDate={setDate} setSlot={setSlot} />
    else if (bookingConfirmed === false) return <InfoForm 
                                                  projectData={projectData} 
                                                  castingData={castingData} 
                                                  date={date} slot={slot} 
                                                  setSlot={setSlot} 
                                                  infoFormState={infoFormState} 
                                                  setInfoFormState={setInfoFormState} 
                                                  bookingInProgress={bookingInProgress}
                                                  setBookingInProgress={setBookingInProgress}
                                                  setBookingConfirmed={setBookingConfirmed}

                                                  organisation={organisation}
                                                  project={project}
                                                  
                                                  email={email}
                                                  setEmail={setEmail}
                                                  auditionee={auditionee}
                                                  setAuditionee={setAuditionee}
                                                  firstName={firstName}
                                                  setFirstName={setFirstName}
                                                  lastName={lastName}
                                                  setLastName={setLastName}
                                                  phone={phone}
                                                  setPhone={setPhone}
                                                />
    else                                 return <BookingConfirmed projectData={projectData} time={date} slot={slot} setBookingInProgress={setBookingInProgress} />
  }

}

export default BookingPage;


function BookingDisabled(props) {

  return (
    <div className='booking-page'>
      <div className='booking-page-title'>
        <h2>
          {props.showName} is not accepting audition bookings at the moment
        </h2>
      </div>
      <p>
        Please check back later to book your audition. <br/><br/>If you believe this is a mistake, please contact the <i>{props.showName}</i> team
      </p>
      <hr/>
      <BookingFooter />
    </div>
  )

}

function DatesDisplay(props) {
  var times = props.times;

  let datesDisplay = times === null? null : (
    times.map((item) => {
      return (<button key={item.id} className='booking-page-option' onClick={() => {props.setDate(item)}}>{PrettifyDate(item.date, true) + ' [' + item.location + ']'}</button>)
    })
  )
  
  return (
    <div className='booking-page'>
      <div className='booking-page-title'>
        <p>Booking Audition For</p>
        <h2>{props.projectData.name}</h2>
        <hr />
      </div>
      {datesDisplay}
      <hr/>
      <BookingFooter />
    </div>
  );
}

function SlotsDisplay(props) {
  const time = props.date;
  var slots = props.castingData.slots;

  slots = slots.filter((x) => {return x.time_id === time.id});

  let slotsDisplay = slots.map((item) => {
    if(item.auditionee_id === null) return (<button key={item.id} className='booking-page-option-bordered' onClick={() => {props.setSlot(item)}}>{item.start}</button>)
    else return (<button key={item.id} className='booking-page-option-bordered-disabled'>{item.start}</button>)
  })

  return (
    <div className='booking-page'>
      <div className='booking-page-title'>
        <p>Booking Audition For</p>
        <h2>{props.projectData.name}</h2>
        <p><b>{PrettifyDate(time.date)}</b></p>
        <button className='booking-page-back-button' onClick={() => props.setDate(null)} >Back</button>
        <hr />
      </div>
      {slotsDisplay}
      <hr/>
      <BookingFooter />
    </div>
  );
}

function InfoForm(props) {
  const time = props.date;
  const slot = props.slot;
  const state = props.infoFormState;
  const setState = props.setInfoFormState;

  const bookingInProgress = props.bookingInProgress;
  const setBookingInProgress = props.setBookingInProgress;

  const organisation = props.organisation;

  const email = props.email;
  const auditionee = props.auditionee;
  const firstName = props.firstName;
  const lastName = props.lastName;
  const phone = props.phone;
  
  var display = null;

  // Enter email
  if(state === 0)
  {
    display = (
      <div className='booking-page-form'>
        <p>University Email:</p>
        <input type='text' placeholder='e.g. me@myemail.com' value={email} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim())}}/>
        <button className='booking-page-button' onClick={async() => {
          if(email === '' || email.split('@').length !== 2) alert('Please enter a valid email');
          else {
            await checkAuditioneeByEmail(email, organisation).then((auditionee) => {
              if(auditionee.exists) {
                props.setAuditionee(auditionee);
                setState(1);
              }
              else {
                setState(2);
              }
            })
          }
        }}>Search</button>
      </div>
    )
  }
  // Auditionee found
  else if(state === 1)
  {
    display = (
      <div className='booking-page-form'>
        <p>Email:</p>
        <input type='text' placeholder='e.g. me@myemail.com' value={email} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim()); setState(0); props.setAuditionee(null)}}/>
        <p style={{...{textAlign: 'center'},...{color: '#2ecc71'}}}>Found your details</p>
        {bookingInProgress? (
          <div style={{...{width: '100%'},...{display: 'flex'},...{justifyContent: 'center'}}}>
            <img src={LoaderImage} width='100px' alt='loader'/>
          </div>
        ) : (
          <button className='booking-page-button' disabled={bookingInProgress} onClick={async() => {
            setBookingInProgress(true);
            await bookAudition({...auditionee, email:email}, slot, props.projectData, time, organisation, props.setBookingConfirmed);
          }}>Book Audition</button>
        )}
      </div>
    )
  }
  // Auditionee needs creating
  else if(state === 2)
  {
    display = (
      <div className='booking-page-form'>
        <p>University Email:</p>
        <input type='text' placeholder='e.g. me@myemail.com' value={email} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim()); setState(0); props.setFirstName(''); props.setLastName(''); props.setPhone('')}}/>
        <p style={{...{textAlign: 'center'},...{color: '#e67e22'}}}>Please enter your details below and <b>ensure they are correct and are your own</b>. Your information will be securely stored for the current season.</p>
        <p>First Name:</p>
        <input type='text' placeholder='e.g. Jane' value={firstName} onChange={(e) => props.setFirstName(e.target.value)} />
        <p>Last Name:</p>
        <input type='text' placeholder='e.g. Doe' value={lastName} onChange={(e) => props.setLastName(e.target.value)} />
        <p>Phone Number:</p>
        <input type='text' placeholder='xxxxx xxxxxx' value={phone} onChange={(e) => props.setPhone(e.target.value)} />
        {bookingInProgress? (
          <div style={{...{width: '100%'},...{display: 'flex'},...{justifyContent: 'center'}}}>
            <img src={LoaderImage} width='100px' alt='loader'/>
          </div>
        ) : (
          <button className='booking-page-button' disabled={bookingInProgress} onClick={async() => {
            setBookingInProgress(true);
            await createAuditioneeAndBookAudition(email, firstName, lastName, phone, slot, props.projectData, time, organisation, props.setBookingConfirmed);
          }}>Book Audition</button>
        )}
      </div>
    )
  }

  return (
    <div className='booking-page'>
      <div className='booking-page-title'>
        <p>Booking Audition For</p>
        <h2>{props.projectData.name}</h2>
        <p><b>{PrettifyDate(time.date)}</b></p>
        <p>at <b>{slot.start}</b></p>
        <button className='booking-page-back-button' disabled={bookingInProgress} onClick={() => {props.setSlot(null); setState(0)}} >Back</button>
        <hr />
      </div>
      {display}
      <hr/>
      <BookingFooter />
    </div>
  );
}

function BookingConfirmed(props) {

  props.setBookingInProgress(false);

  return (
    <div className='booking-page'>
      <div className='booking-page-title'>
        <p>Booking Confirmed For</p>
        <h1>{props.projectData.name}</h1>
        <p>on</p>
        <h3>{PrettifyDate(props.time.date)}</h3>
        <p>at</p>
        <h3>{props.slot.start}, {props.time.location}</h3>
        <hr />
      </div>
      <p>
        You will receive an email soon confirming your booking
      </p>
      <p>
        If you don't see this email, check your spam folder
      </p>
      <hr/>
      <BookingFooter />
    </div>
  );
}

function BookingFooter() {
  return (
    <div className='booking-page-footer' style={{...{cursor: 'pointer'}}} onClick={() => window.location.replace('/')}>
      <img src={Logo} width='50px' />
      <div>
        Powered by Shoru CastingBot
      </div>
      <div style={{opacity: 0.4, fontSize: '8px', marginTop: '-8px'}}>
        © 2026 Thomas McCarthy
      </div>
    </div>
  )
}